import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SectionHeaderComponent } from '@app/widgets/components';
import { TuiIcon } from '@taiga-ui/core';
import { CountUpModule } from 'ngx-countup';

@Component({
  selector: 'app-enterprise-scalability-section',
  imports: [CountUpModule, SectionHeaderComponent, TuiIcon],
  templateUrl: './enterprise-scalability-section.component.html',
  styleUrl: './enterprise-scalability-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EnterpriseScalabilitySectionComponent {}
